// // /lib/firebase.js
// import { initializeApp } from "firebase/app";
// // import { getAnalytics } from "firebase/analytics";
// import { getDatabase } from "firebase/database";

// const firebaseConfig = {
//   apiKey: "AIzaSyD1AxbgOcdfBL01-DbFtPs6Xk7TbQsc7CE",
//   authDomain: "secretchat-b8e8b.firebaseapp.com",
//   databaseURL: "https://secretchat-b8e8b-default-rtdb.europe-west1.firebasedatabase.app",
//   projectId: "secretchat-b8e8b",
//   storageBucket: "secretchat-b8e8b.firebasestorage.app",
//   messagingSenderId: "1041535867565",
//   appId: "1:1041535867565:web:4197f508b4f01fa4590424",
//   measurementId: "G-KK7YGVM5KW"
// };

// const app = initializeApp(firebaseConfig);
// // const analytics = getAnalytics(app);
// const db = getDatabase(app);

// export { db };

import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
	apiKey: "AIzaSyBf_ba9y0sB8k9xNcEyiz14KcshsH6IgBM",
	authDomain: "blog-views-7a2d5.firebaseapp.com",
	projectId: "blog-views-7a2d5",
	storageBucket: "blog-views-7a2d5.appspot.com",
	messagingSenderId: "869399106459",
	appId: "1:869399106459:web:9c3a3ad598a31cf9b4073e",
	measurementId: "G-QMRJMDB2W3",
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };